module.exports = __webpack_public_path__ + "static/media/galerija_2014 (24).c6759430.jpg";